import { useError } from "@/components/ui/overlays/ErrorBanner";
import { Validate } from "./validate/Validate";
import { Load } from "./load/Load";
import { Preload } from "./preload/Preload";
import type { useMachineProps } from "./types";
import { useEffect } from "react";

/**
 * By wrapping each phase logic in components we isolate their reactive dependencies, ensuring they do not re-render the entire application.
 * Since each phase logic should be isolated it makes more sense to ensure it doesn't communicate with the main component.
 */

export function Machine(props: useMachineProps) {
  const { state } = props;
  const { toggleError } = useError();

  useEffect(() => {
    if (state?.matches("error")) {
      toggleError("something went wrong");
    }
  }, [state, toggleError]);

  if (!state) return null; // Add a guard clause to prevent crash if state is undefined.
  if (state.matches("done")) return null;
  if (state.matches("validating")) return <Validate {...props} />;
  if (state.matches("loading")) return <Load {...props} />;
  if (state.matches("preloading")) return <Preload {...props} />;
  if (state.matches("error")) return null;
  return null;
}

// Note: Tests for Machine live in __tests__ to keep runtime code clean.
